// src/api/user.js
import { get, post } from "@/utils/request";
import i18n from "@/i18n";
//
// 注册接口
export function getregister(data) {
  return post("register", data);
}
// 登录接口
export function getlogin_pc(data) {
  return post("login_pc", data);
}
export function toLogoff() {
  return post("logoff");
}
// 首页接口
export function getbannerList(data) {
  return post("bannerList", data, { loading: false });
}
// 个人信息接口
export function getuser(data) {
  return post("user", data, { loading: false });
}
export function getbalance(data) {
  return post("balance", data, { loading: false });
}
// 优惠活动tabs接口
export function getactivitytype(data) {
  return post("activitytype", data, { loading: false });
}
// 优惠活动列表接口
export function getactivitylist(data) {
  return post("activitylist", data);
}
// 优惠活动详情接口
export function getactivitydeatil(data) {
  return post("activitydeatil", data);
}
// 优惠活动详情申请接口
export function getdoactivityapply(data) {
  return post("doactivityapply", data);
}
// 优惠活动申请记录
export function getactivityApplyLog(data) {
  return post("activityApplyLog", data, { loading: false });
}
// 台球类型接口
export function gettqactivitytype(data) {
  return post("tqactivitytype", data, { loading: false });
}
// 台球列表接口
export function gettqactivitylist(data) {
  return post("tqactivitylist", data);
}
// 台球详情接口
export function gettqactivitydeatil(data) {
  return post("tqactivitydeatil", data);
}
// app信息接口
export function getapp(data) {
  return post("app", data, { loading: false });
}
// 弹出公告接口
export function getwebnotice(data) {
  return post("webnotice", data, { loading: false });
}
// 游戏列表接口
export function getgameList(data) {
  return get("game/list", data, { loading: false });
}
// 游戏列表接口
export function getGameUrl(data) {
  return post("getGameUrl", data);
}
// 游戏列表接口
export function getarticle(data) {
  return post("article", data);
}
// 修改登录密码
export function geteditPassword(data) {
  return post("editPassword", data, { loading: { message: i18n.t("messages.changingPassword") } });
}
// 修改支付密码
export function geteditPayPassword(data) {
  return post("editPayPassword", data, { loading: { message: i18n.t("messages.changingPassword") } });
}
// 上传头像
export function getuploadimg(data) {
  return post("uploadimg", data, { message: i18n.t("messages.uploadingAvatar") });
}
// 返水接口
export function getfanshui(data) {
  return post("getfanshui", data);
}
// 投注记录接口
export function getbetrecord(data) {
  return post("betrecord", data);
}
// 交易记录接口
export function gettransrecord(data) {
  return post("gettransrecord", data);
}
// 平台接口
export function getbalancelist(data) {
  return post("balancelist", data, { loading: false });
}
// 申请代理接口
export function getapplyagentdo(data) {
  return post("applyagentdo", data);
}
// 广播信息接口
export function gethomenotice(data) {
  return post("homenotice", data, { loading: false });
}
// 代理链接接口
export function getAgentLoginUrl(data) {
  return get("getAgentLoginUrl", data, { loading: false });
}
// 余额转游戏接口
export function getbalancetogame(data) {
  return post("balancetogame", data);
}
// 一键回收接口
export function gethuishou(data) {
  return post("huishou", data);
}
// 添加USDT接口
export function getbindcard(data) {
  return post("bindcard", data);
}
// USDT地址接口
export function getcard(data) {
  return post("getcard", data);
}
// 各平台的余额接口
export function getapimoney(data) {
  return post("apimoney", data);
}
// 提现接口
export function getwithdraw(data) {
  return post("withdraw", data);
}
// 银行列表接口
export function getbanklist(data) {
  return post("banklist", data);
}
// 上传头像
export function getuploadalicode(data) {
  return post("uploadalicode", data, { message: i18n.t("messages.uploadingQr") });
}
// 提现设置
export function getwithdrawset(data) {
  return post("withdrawset", data, { loading: false });
}
// 充值方式
export function get_pay_way(data) {
  return get("get_pay_way", data, { loading: false });
}
// 支付最大最小金额
export function getPayRange(data) {
  return post("getPayRange", data, { loading: false });
}
// 充值生成订单
export function getrecharge(data) {
  return post("recharge", data, { message: i18n.t("messages.generatingOrder") });
}
// 充值详情
export function getpayinfo(data) {
  return post("payinfo", data, { message: i18n.t("messages.generatingOrder") });
}
// 站内信
export function getnoticeList(data) {
  return post("noticeList", data, { loading: false });
}
// 扶持首页
export function getfuchiindex(data) {
  return post("fuchiindex", data, { loading: false });
}
// 紫色游戏列表
export function getziGametype(data) {
  return post("zi-gametype", data, { loading: false });
}
// 游戏分类
export function getGametype(data) {
  return post("gametype", data, { loading: false });
}
// 平台列表
export function getPlatlist(data) {
  return post("platlist", data, { loading: false });
}
// 紫色获取游戏链接
export function getziGetgameurl(data) {
  return post("zi-getgameurl", data, { loading: false });
}
// 紫色余额转游戏
export function getziBalancetogame(data) {
  return post("zi-balancetogame", data, { loading: false });
}
// 紫色一键回收
export function getziHuishou(data) {
  return post("zi-huishou", data, { loading: false });
}
// 紫色获取游戏链接
export function getGamelist(data) {
  return post("zi-gamelist", data, { loading: false });
}
// 游戏列表（电子/捕鱼下级）
export function getGameListApi(data) {
  return post("gamelist", data, { loading: false });
}
// 紫色vip列表
export function getziUservip(data) {
  return post("zi-uservip", data, { loading: false });
}
// 紫色朋友圈列表
export function getPyqList(data) {
  return post("pyq-list", data, { loading: false });
}
// 紫色朋友圈-点赞
export function getPyqaddlike(data) {
  return post("pyq-addlike", data, { loading: false });
}
// 紫色朋友圈-评论
export function getPyqaddcomment(data) {
  return post("pyq-addcomment", data, { loading: false });
}
// 紫色朋友圈-发布
export function getPyqaddpyq(data) {
  return post("pyq-addpyq", data, { loading: false });
}
// 紫色朋友圈-上传图片
export function getUploadimg(data) {
  return post("pyq-uploadimg", data, { loading: false });
}
// 紫色获取单篇文章
export function getOnearticle(data) {
  return post("onearticle", data, { loading: false });
}
// 紫色扶持用户
export function getFuchiuser(data) {
  return post("fuchiuser", data, { loading: false });
}
// 紫色扶持用户记录列表
export function getFuchiuserlist(data) {
  return post("fuchiuserlist", data, { loading: false });
}
// 紫色查找扶持用户
export function getFuchifind(data) {
  return post("fuchifind", data, { loading: false });
}
// 紫色邀请链接
export function getinvite(data) {
  return post("getinvite", data, { loading: false });
}
// 领取返水
export function getziLingqufanshui(data) {
  return post("zi-lingqufanshui", data, { loading: false });
}
// 绿色获取佣金详情
export function getyongjin(data) {
  return post("zi-getyongjin", data, { loading: false });
}
// 返佣记录
export function getfanyonglist(data) {
  return post("zi-fanyonglist", data, { loading: false });
}
// 邀请列表
export function getyaoqinglist(data) {
  return post("zi-yaoqinglist", data, { loading: false });
}
// 推广首页
export function getlvinvite(data) {
  return post("lvinvite", data, { loading: false });
}
// 我的数据
export function getmyshuju(data) {
  return post("myshuju", data, { loading: false });
}
// 我的业绩 我的佣金
export function getlvmyyeji(data) {
  return post("lvmyyeji", data, { loading: false });
}
// 我的下级
export function getlvxiajiinfo(data) {
  return post("lvxiajiinfo", data, { loading: false });
}
// 我的下级投注
export function getlvxiajibet(data) {
  return post("lvxiajibet", data, { loading: false });
}
// 我的下级财务
export function getlvxiajicaiwu(data) {
  return post("lvxiajicaiwu", data, { loading: false });
}
// 返佣比例
export function getfanyongbili(data) {
  return post("fanyongbili", data, { loading: false });
}
// 人头宝箱页面
export function getlvinvitebox(data) {
  return post("lvinvitebox", data, { loading: false });
}
// 领取人头宝箱
export function getlvinviteboxlingqu(data) {
  return post("lvinviteboxlingqu", data, { loading: false });
}
// 提现类型
export function getTixiantype(data) {
  return post("zi-tixiantype", data, { loading: false });
}
// 充值记录
export function getrechargerecord(data) {
  return post("getrechargerecord", data, { loading: false });
}
// 充值方式
export function getPayway(data) {
  return post("zi-payway", data, { loading: false });
}
// 充值
export function getChongzhi(data) {
  return post("zi-chongzhi", data, { loading: false });
}
// 充值方式渠道
export function getzipaywayproduct(data) {
  return post("zi-zipaywayproduct", data, { loading: false });
}
// 返佣排行榜
export function getYongjinbang(data) {
  return post("zi-yongjinbang", data, { loading: false });
}
